"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { c } from "@/lib/vster/theme";
import Icon from "@/components/vster/Icon";

// 공고문 삭제 — 수퍼유저 전용. 확인 모달 → POST /api/programs/[id]/delete.
//   삭제 시: 공고문 제거 + 수집글 비지원 판정(잠금) + 발췌 공고파일 삭제(orphan).
export default function DeleteButton({ docId }: { docId: number }) {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function run() {
    setErr(null);
    setBusy(true);
    try {
      const res = await fetch(`/api/programs/${docId}/delete`, { method: "POST" });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { setErr(d.error ?? "삭제에 실패했습니다."); setBusy(false); return; }
      router.push("/programs");
    } catch { setErr("처리 중 오류가 발생했습니다."); setBusy(false); }
  }

  return (
    <>
      <button
        type="button" onClick={() => setOpen(true)} title="이 공고문을 삭제하고 수집글을 비지원으로 처리합니다"
        style={{ display: "inline-flex", alignItems: "center", gap: 5, border: `1px solid ${c.line}`, background: c.surface, color: c.danger ?? "#d33", borderRadius: 9, padding: "8px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}
      >
        <Icon name="delete" size={16} />삭제
      </button>

      {open ? (
        <div onClick={() => !busy && setOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(14,23,38,.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, padding: 20 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: c.surface, borderRadius: 16, padding: 24, maxWidth: 420, width: "100%", boxShadow: "0 20px 60px -20px rgba(0,0,0,.4)" }}>
            <h3 style={{ fontSize: 18, fontWeight: 800, margin: "0 0 10px", color: c.ink, display: "flex", alignItems: "center", gap: 8 }}>
              <Icon name="warning" size={20} color={c.danger ?? "#d33"} />공고문 삭제
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.6, color: c.muted, margin: "0 0 8px" }}>
              이 공고문을 삭제합니다. 되돌리기 어려운 작업입니다:
            </p>
            <ul style={{ fontSize: 13.5, lineHeight: 1.7, color: c.ink, margin: "0 0 18px", paddingLeft: 18 }}>
              <li>공고문 삭제(목록·검색에서 제거)</li>
              <li>수집된 글을 <b>비지원사업</b>으로 확정(잠금)</li>
              <li>발췌된 공고파일 삭제(다른 글과 공유 시 보존)</li>
            </ul>
            {err ? <p style={{ fontSize: 13, color: c.danger ?? "#d33", margin: "0 0 12px" }}>{err}</p> : null}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" onClick={() => setOpen(false)} disabled={busy} style={{ border: `1px solid ${c.line}`, background: c.surface, color: c.ink, borderRadius: 9, padding: "9px 16px", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>취소</button>
              <button type="button" onClick={run} disabled={busy} style={{ border: "none", background: c.danger ?? "#d33", color: "#fff", borderRadius: 9, padding: "9px 18px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: busy ? 0.6 : 1 }}>{busy ? "삭제 중…" : "삭제"}</button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
